import { useState } from 'react'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import '../../components/front/IRANSans-normal'
import { reverse } from 'lodash'
import { Currency } from './Currency'
import { hashIds } from '../../utils'
import dayjs from 'dayjs'
import jalaliday from 'jalaliday'

dayjs.extend(jalaliday)

async function downloadAsPDF(purchaseOrder) {
    if (!process.browser) return
    const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: 'a4'
    })
    doc.setFont('IRANSans')

    const halign = 'right'
    doc.autoTable({
        theme: 'plain',
        styles: { font: 'IRANSans', cellPadding: 10 },
        showHead: false,
        head: [],
        body: [
            [
                {
                    content: [
                        'تاريخ',
                        ' :',
                        dayjs(purchaseOrder.created_at).calendar('jalali').locale('fa').format('YYYY/MM/DD')
                    ],
                    styles: { halign: halign }
                },
                {
                    content: ['شماره پيگيري', ' :', hashIds(purchaseOrder.id)],
                    styles: { halign: halign }
                },
                {
                    content: [`${purchaseOrder.metas?.first_name?.value} ${purchaseOrder.metas?.last_name?.value}`],
                    styles: { halign: halign }
                }
            ],
            [
                {
                    content: ['شماره تلفن همراه', ' :', purchaseOrder.metas?.mobile?.value],
                    styles: { halign: halign }
                },
                {
                    content: [
                        `${purchaseOrder.metas?.flat_no?.value}`,
                        'واحد',
                        `${purchaseOrder.metas?.block_no?.value}`,
                        'پلاک ',
                        ' ، ',
                        `${purchaseOrder.metas?.address?.value}`,
                        ' :',
                        'آدرس'
                    ],
                    colSpan: 2,
                    styles: { halign: halign }
                }
            ],
            [
                { content: [] },
                {
                    content: ['کدپستي', ' :', `${purchaseOrder.metas?.postCode?.value}`],
                    styles: { halign: halign }
                },
                {
                    content: ['شماره تماس', ' :', `${purchaseOrder.metas?.phone?.value}`],
                    styles: { halign: halign }
                }
            ]
        ],
        willDrawCell: function ({ cell, section }) {
            if (section === 'body' && cell && Array.isArray(cell.raw?.content)) {
                cell.text = [reverse(cell.raw.content).join(' ')]
            }
        },
        tableLineWidth: 1,
        tableLineColor: [33, 43, 55],
        didDrawPage: function (data) {
            // Header
            var pageSize = data.doc.internal.pageSize

            data.doc.setTextColor(0)
            data.doc.addImage('/img/logo.png', 'PNG', pageSize.width - data.settings.margin.right - 35, 8, 35, 35)

            data.doc.setFontSize(15)
            data.doc.text('فروشگاه اینترنتی کاج استور', pageSize.width - data.settings.margin.right - 170, 28, {
                halign: 'right'
            })
        },
        margin: { top: 50 }
    })
    doc.autoTable({
        theme: 'plain',
        styles: { font: 'IRANSans', halign: 'right', cellPadding: 10, lineColor: [79, 70, 229], lineWidth: 1 },
        headStyles: { fontStyle: 'bold', fillColor: [224, 231, 255] },
        head: [['جمع مبلغ', 'تعداد / مقدار', 'شرح کالا', 'کد کالا']],
        body: purchaseOrder?.cart.items.map((c) => [
            c.qty * c.final_price + '',
            c.qty + '',
            `${c.name} ${c.model}`,
            c.sku
        ]),
        tableLineWidth: 1,
        tableLineColor: [79, 70, 229]
    })
    doc.autoTable({
        theme: 'plain',
        styles: { font: 'IRANSans', halign: 'right', cellPadding: 8, lineColor: [79, 70, 229], lineWidth: 1 },
        showHead: false,
        body: [
            [
                {
                    content: ['مبلغ نهایی', purchaseOrder?.cart.totals.total + ''],
                    styles: { halign: 'center' }
                },
                {
                    content: ['تخفیف', purchaseOrder?.cart.totals.items_discounts + ''],
                    styles: { halign: 'center' }
                },
                {
                    content: ['هزینه ارسال', purchaseOrder?.metas?.shipping_method?.value + ''],
                    styles: { halign: 'center' }
                }
            ]
        ],
        willDrawCell: function ({ cell, section }) {
            if (section === 'body' && cell && Array.isArray(cell.raw?.content)) {
                cell.text = [reverse(cell.raw.content).join(' ')]
            }
        },
        tableLineWidth: 1,
        tableLineColor: [79, 70, 229]
    })
    doc.save('factor.pdf')
}

function Checkout({ purchaseOrder }) {
    const [tableId] = useState(() => 't' + (Math.random() * 10000 + '').replace('.', ''))

    return (
        <>
            <table className="w-8/12" id={tableId}>
                <tbody>
                    <tr>
                        <td>
                            <table className="border border-gray-800 w-full mb-4">
                                <tbody>
                                    <tr>
                                        <td className="p-2 text-right">
                                            {purchaseOrder.metas?.first_name?.value}{' '}
                                            {purchaseOrder.metas?.last_name?.value}
                                        </td>
                                        <td className=" p-2 text-right">شماره پيگيري: {hashIds(purchaseOrder.id)}</td>
                                        <td className="p-2 text-right">
                                            {dayjs(purchaseOrder.created_at)
                                                .calendar('jalali')
                                                .locale('fa')
                                                .format('YYYY/MM/DD')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="p-2 text-right" colSpan="2">
                                            آدرس: {purchaseOrder.metas?.address?.value}, پلاک{' '}
                                            {purchaseOrder.metas?.block_no?.value}، واحد
                                            {purchaseOrder.metas?.flat_no?.value}
                                        </td>
                                        <td className="p-2 text-right">
                                            شماره تلفن همراه: {purchaseOrder.metas?.mobile?.value}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="p-2 text-right">
                                            شماره تماس: {purchaseOrder.metas?.phone?.value}
                                        </td>
                                        <td className="p-2 text-right" colSpan="2">
                                            کدپستي: {purchaseOrder.metas?.postCode?.value}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table className="border border-indigo-800 w-full">
                                <thead>
                                    <tr>
                                        <th className="border border-indigo-600 p-2 bg-indigo-100" colSpan="2">
                                            کد کالا
                                        </th>
                                        <th className="border border-indigo-600 p-2 bg-indigo-100" colSpan="2">
                                            شرح کالا
                                        </th>
                                        <th className="border border-indigo-600 p-2 bg-indigo-100" colSpan="2">
                                            تعداد / مقدار
                                        </th>
                                        <th className="border border-indigo-600 p-2 bg-indigo-100" colSpan="2">
                                            جمع مبلغ
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {purchaseOrder?.cart?.items.map((c) => (
                                        <tr key={c.id}>
                                            <td className="border border-indigo-600 p-2 text-center" colSpan="2">
                                                {c.sku}
                                            </td>
                                            <td className="border border-indigo-600 p-2 text-center" colSpan="2">
                                                {c.name} {c.model}
                                            </td>
                                            <td className="border border-indigo-600 p-2 text-center" colSpan="2">
                                                {c.qty}
                                            </td>
                                            <td className="border border-indigo-600 p-2 text-center" colSpan="2">
                                                <Currency value={c.price} finalValue={c.final_price} />
                                            </td>
                                        </tr>
                                    ))}

                                    <tr>
                                        <td className="border border-indigo-600 p-2 text-center font-bold" colSpan="2">
                                            هزینه ارسال:{' '}
                                            <Currency value={purchaseOrder?.metas?.shipping_method?.value} />
                                        </td>
                                        <td className="border border-indigo-600 p-2 text-center font-bold" colSpan="2">
                                            تخفیف: <Currency value={purchaseOrder?.cart.totals.items_discounts || 0} />
                                        </td>
                                        <td className="border border-indigo-600 p-2 text-center font-bold" colSpan="4">
                                            مبلغ نهایی: <Currency value={purchaseOrder?.cart.totals.total || 0} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="flex justify-start items-baseline w-8/12 ">
                <button
                    onClick={() => {
                        downloadAsPDF(purchaseOrder)
                    }}
                    className="mt-6 bg-indigo-500 text-indigo-100 rounded-md px-5 py-1">
                    دانلود
                </button>
                <span className="inline-block ms-2">برای دریافت فایل PDF فاکتور کلیک کنید</span>
            </div>
        </>
    )
}

export { Checkout, downloadAsPDF }
